import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, KeepAlive as _KeepAlive, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/mobile/points-star-icon.png'
import _imports_1 from '@/assets/images/mobile/icon_more_1.png'
import _imports_2 from '@/assets/images/mobile/share-task-icon.png'
import _imports_3 from '@/assets/images/mobile/task1-e1-icon.png'


const _hoisted_1 = { class: "container-mobile bg-myPoints overflow-auto" }
const _hoisted_2 = { class: "content content-my-points" }
const _hoisted_3 = { class: "title text-white pt-5 mx-3" }
const _hoisted_4 = { class: "available-points d-flex align-items-center mt-3 mx-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "my-points"
}, null, -1)
const _hoisted_6 = { class: "position-relative ms-1 mb-2" }
const _hoisted_7 = { class: "available-points-body d-flex justify-content-between align-items-center mx-3" }
const _hoisted_8 = { class: "points" }
const _hoisted_9 = { class: "points-value mb-0 text-white fw-medium" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "align-self-end ms-1",
  src: _imports_1,
  alt: "more",
  style: {"width":"10px","height":"10px"}
}, null, -1)
const _hoisted_11 = { class: "cash-points-lable mb-0 mt-1" }
const _hoisted_12 = { class: "cash-points-value text-white ms-1 fw-medium" }
const _hoisted_13 = { class: "pending-cash position-relative rounded-3 mb-3 d-flex flex-wrap justify-content-around p-3 mt-3 mx-3" }
const _hoisted_14 = { class: "pending fw-medium mb-1 text-center" }
const _hoisted_15 = { class: "label text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right pe-0" }, null, -1)
const _hoisted_17 = { class: "cash fw-medium mb-1 text-center" }
const _hoisted_18 = { class: "label text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right pe-0" }, null, -1)
const _hoisted_20 = { class: "tasks-content p-3" }
const _hoisted_21 = { class: "task task-1 rounded-3 p-2" }
const _hoisted_22 = { class: "title-task text-black fw-medium" }
const _hoisted_23 = { class: "content-task d-flex justify-content-between align-items-center mt-3" }
const _hoisted_24 = { class: "d-flex gap-2 align-items-center pb-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "align-self-start",
  src: _imports_2,
  alt: "share",
  style: {"width":"32px","height":"32px"}
}, null, -1)
const _hoisted_26 = { class: "description me-4" }
const _hoisted_27 = { class: "d-flex align-items-end flex-wrap" }
const _hoisted_28 = { class: "text-black fs-6 mb-0 me-1" }
const _hoisted_29 = { class: "mb-0 e e-orange d-flex align-items-center me-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "yuan",
  style: {"width":"11px"}
}, null, -1)
const _hoisted_31 = { class: "fw-medium" }
const _hoisted_32 = { class: "mb-0 e e-gray" }
const _hoisted_33 = { class: "exchange-packages p-2 bg-white mt-3 rounded-3" }
const _hoisted_34 = { class: "exchange-packages-title m-1 text-black fw-medium" }
const _hoisted_35 = { class: "packages-content m-1 d-flex flex-wrap justify-content-between" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "me-2" }
const _hoisted_38 = { class: "me-2" }
const _hoisted_39 = { class: "points-val-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_redeem_dialog = _resolveComponent("redeem-dialog")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_message_redeem_dialog = _resolveComponent("message-redeem-dialog")!
  const _component_confirm_redeem_dialog = _resolveComponent("confirm-redeem-dialog")!
  const _component_success_redeem_dialog = _resolveComponent("success-redeem-dialog")!
  const _component_field_redeem_dialog = _resolveComponent("field-redeem-dialog")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($setup.local.my_points_1), 1),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.local.my_points_2), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              role: "button",
              class: "d-flex",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToPointsDetails()))
            }, [
              _createElementVNode("p", _hoisted_9, _toDisplayString($setup.availableCashablePoints +
                            $setup.availableSharPoints), 1),
              _hoisted_10
            ]),
            _createElementVNode("p", _hoisted_11, [
              _createTextVNode(_toDisplayString($setup.local.my_points_3), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.availableCashablePoints), 1)
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToWithdraw())),
            class: "Withdrawal-btn p-2 fw-medium text-white border-0 rounded-5 align-self-end mb-1"
          }, _toDisplayString($setup.local.my_points_4), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            role: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goToPendingPoints()))
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString($setup.pendingPoints), 1),
            _createElementVNode("p", _hoisted_15, [
              _createTextVNode(_toDisplayString($setup.local.my_points_5) + " ", 1),
              _hoisted_16
            ])
          ]),
          _createElementVNode("div", {
            role: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goToEarnMony()))
          }, [
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.amount), 1),
            _createElementVNode("p", _hoisted_18, [
              _createTextVNode(_toDisplayString($setup.local.my_points_6) + " ", 1),
              _hoisted_19
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString($setup.local.my_points_7), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", _hoisted_28, _toDisplayString($setup.local.my_points_8), 1),
                    _createElementVNode("p", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("span", _hoisted_31, "+" + _toDisplayString($setup.shareRebate[0].new_purchase_percent) + "%" + _toDisplayString($setup.local.my_points_9), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_32, _toDisplayString($setup.local.my_points_10), 1)
                ])
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(["task-btn align-self-start text-white border-0 rounded-4 p-1", [_ctx.$route.query.lang?.toString().toLowerCase() == 'en' ? 'task-btn-en' : '']]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goToShare()))
              }, _toDisplayString($setup.local.my_points_11), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString($setup.local.my_points_12), 1),
            _withDirectives(_createElementVNode("div", { class: "empty-cards p-3" }, _toDisplayString($setup.local.my_points_13), 513), [
              [_vShow, $setup.packages.length == 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.packages, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item rounded-2 p-2 mt-2 d-flex flex-wrap align-content-start",
                  onClick: ($event: any) => ($setup.selectPackage(item)),
                  role: "button",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(item.bandwidth_limit) + "GB", 1),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_39, _toDisplayString(item.price_coins) + _toDisplayString($setup.local.my_points_15), 1)
                ], 8, _hoisted_36))
              }), 128))
            ], 512), [
              [_vShow, $setup.packages.length > 0]
            ])
          ])
        ])
      ]),
      _withDirectives(_createVNode(_component_mask_layer, null, null, 512), [
        [_vShow, _ctx.showLoading || _ctx.showRedeem || _ctx.showMessageRedeem || _ctx.showConfirm  || _ctx.showSuccess || _ctx.showField]
      ]),
      (_openBlock(), _createBlock(_KeepAlive, null, [
        _createVNode(_component_Fade, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_redeem_dialog, {
              onHide: _cache[5] || (_cache[5] = ($event: any) => ($setup.closeComponent('showRedeem'))),
              onShowTips: _cache[6] || (_cache[6] = (msg) => $setup.showErrorMessage(msg)),
              onConfirm: _cache[7] || (_cache[7] = (msg, username) => $setup.redeemPackage(msg, username, _ctx.selectedPackage)),
              package: _ctx.selectedPackage
            }, null, 8, ["package"]), [
              [_vShow, _ctx.showRedeem]
            ])
          ]),
          _: 1
        })
      ], 1024)),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_message_redeem_dialog, {
            onHide: _cache[8] || (_cache[8] = ($event: any) => ($setup.closeComponent('showMessageRedeem'))),
            message: _ctx.messageRedeem,
            title: _ctx.titleRedeem
          }, null, 8, ["message", "title"]), [
            [_vShow, _ctx.showMessageRedeem]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_confirm_redeem_dialog, {
            onHide: _cache[9] || (_cache[9] = ($event: any) => ($setup.closeComponent('showConfirm'))),
            onConfirm: _cache[10] || (_cache[10] = ($event: any) => ($setup.confirmRedeem(_ctx.selectedPackage))),
            package: _ctx.selectedPackage,
            username: _ctx.confirmedUsername
          }, null, 8, ["package", "username"]), [
            [_vShow, _ctx.showConfirm]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_success_redeem_dialog, {
            onKnew: _cache[11] || (_cache[11] = ($event: any) => ($setup.closeComponent('showSuccess')))
          }, null, 512), [
            [_vShow, _ctx.showSuccess]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_field_redeem_dialog, {
            package: _ctx.selectedPackage,
            username: _ctx.confirmedUsername,
            availablePoints: $setup.availableCashablePoints + $setup.availableSharPoints,
            onHide: _cache[12] || (_cache[12] = ($event: any) => ($setup.closeComponent('showField'))),
            onShowTips: _cache[13] || (_cache[13] = (msg) => $setup.showErrorMessage(msg))
          }, null, 8, ["package", "username", "availablePoints"]), [
            [_vShow, _ctx.showField]
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
        [_vShow, _ctx.showLoading]
      ])
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}